module.exports = __webpack_public_path__ + "img/avatar_crop.02987bf4.png";